module.exports = __webpack_public_path__ + "img/wrong.ebc4e08a.png";